import app from 'flarum/forum/app';

import extenders from './extenders';

export { default as extend } from './extend';

app.initializers.add('xtreh-phoenix', () => {
    extenders();
}, -1);

// Expose compat API
import extCompat from '../forum/compat';
// @ts-expect-error
import { compat } from '@flarum/core/forum';

Object.assign(compat, extCompat);
